import React, { useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import styles from "../events.module.scss";
import EventMainInfo from "../../../components/event/EventMainInfo";
import { useEventStore } from "../../../components/event/store";
import EventMainData from "../../../components/event/EventMainData";
import BonusesBlock from "../../../components/mainPageBlocks/bonusesBlock";
import { ModalEventJoinedUsers } from "../../../components/event/ui/EventMainData/EventJoinedUsers";
import { Modal } from "semantic-ui-react";
import SmartHeader from "../../../components/SmartHeader/SmartHeader";
import { GetServerSideProps } from "next";
import { customGetServerSideProps } from "../../../utils/misc";

const Event = ({ initialData }) => {
  const router = useRouter();
  const eventID = router.query.id as string;
  const {
    initEvent,
    isLoading,
    eventData,
    clearEvent,
    authStore,
    setEventID,
    setEventData,
    setLoading,
  } = useEventStore();
  useEffect(() => {
    if (!initialData) {
      initEvent(eventID);
    } else {
      setEventID(eventID);
      setEventData(initialData);
      setLoading(false);
    }
    return () => {
      clearEvent();
    };
  }, [authStore.user, initialData, router]);

  const metaContent = useMemo(() => {
    if (!eventData)
      return `${(initialData || eventData || "")?.description
        ?.replace(/(<([^>]+)>)/gi, "")
        ?.slice(0, 132)}...`;
  }, [eventData, initialData]);

  return (
    <SmartHeader
      title={(initialData || eventData)?.name}
      description={metaContent}
      spinner={isLoading || !eventData}
      image={
        (initialData || eventData)?.author?.type === "organization"
          ? (initialData || eventData)?.author?.image
          : undefined
      }
    >
      <div>
        <EventJoinedUsersModal />
        <div className={styles.EventMainInfo}>
          <EventMainInfo />
        </div>
        <div className={styles.EventMainData}>
          <EventMainData />
        </div>
        <div className={styles.EventMainBonuses}>
          <BonusesBlock titleClass={styles.EventMainBonuses_Title} />
        </div>
      </div>
    </SmartHeader>
  );
};

const EventJoinedUsersModal = () => {
  const { isModalOpen, setIsModalOpen } = useEventStore();

  return (
    <Modal
      style={{ padding: 0 }}
      open={isModalOpen}
      className={styles.EventModal}
      onClose={() => {
        setIsModalOpen(false);
      }}
    >
      <ModalEventJoinedUsers />
    </Modal>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const id = context.query?.id;
  return await customGetServerSideProps(`/api/events/${id}/`, context);
};

export default Event;
